import Api, { FetchMethodType } from './Api';

export interface PeriodMetrics {
  mtdValue: number;
  ytdValue: number;
}

export interface UserFinancialMetrics {
  spending: PeriodMetrics | null;
  income: PeriodMetrics | null;
  ivi: number | null;
  evi: number | null;
}

export interface FinancialMetricsApi {
  getFinancialMetrics(applicationId: string): Promise<UserFinancialMetrics>;
}

export default class FinancialMetricsRestApi extends Api implements FinancialMetricsApi {
  public async getFinancialMetrics(applicationId: string): Promise<UserFinancialMetrics> {
    const data = await this.fetch<UserFinancialMetrics>(`/financialMetrics/${applicationId}`, {
      method: FetchMethodType.GET,
    });
    return data;
  }
}
